import './components/index'
import Vault from "../../../web-sh/src/pages/admin/vault";

export default Vault